export default "__VITE_ASSET__DAlHzQmO__"